import { createAsyncThunk } from "@reduxjs/toolkit";

import magnifiAPI from "../../services/api/magnifi";

export const getAccountStorages = createAsyncThunk("storage/getAccountStorages", async (payload) => {
  try {
    const response = await magnifiAPI.getAccountStorages(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});

export const getAssignedOrganization = createAsyncThunk("storage/getAssignedOrganization", async (payload) => {
  try {
    const response = await magnifiAPI.getAssignedOrganization(payload);

    return response.data;
  } catch (error) {
    console.error(error);
  }
});

export const updateStorageFolder = createAsyncThunk("storage/updateStorageFolder", async (payload) => {
  try {
    const response = await magnifiAPI.updateStorageFolder(payload);

    return response.data;
  } catch (error) {
    console.error(error);
  }
});

export const getAccountStoragesByEntityId = createAsyncThunk(
  "storage/getAccountStoragesByEntityId",
  async (payload) => {
    try {
      const response = await magnifiAPI.getAccountStoragesByEntityId(payload);

      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
);

export const deleteAccountStoragesById = createAsyncThunk("storage/deleteAccountStorages", async (payload) => {
  try {
    const response = await magnifiAPI.deleteAccountStoragesById(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});
